<script setup>
  import { computed } from "vue";
  import { REPORT_THEME_DEFAULT_COLORS } from "@/lib/chartPalettes";
  import BarClusteredPreview from "./previews/BarClusteredPreview.vue";
  import BarStacked100Preview from "./previews/BarStacked100Preview.vue";
  import ColumnClusteredPreview from "./previews/ColumnClusteredPreview.vue";
  import ColumnStacked100Preview from "./previews/ColumnStacked100Preview.vue";
  import PiePreview from "./previews/PiePreview.vue";
  import DoughnutPreview from "./previews/DoughnutPreview.vue";

  const CHART_COMPONENTS = {
    BAR_CLUSTERED: BarClusteredPreview,
    BAR_STACKED_100: BarStacked100Preview,
    COLUMN_CLUSTERED: ColumnClusteredPreview,
    COLUMN_STACKED_100: ColumnStacked100Preview,
    PIE: PiePreview,
    PIE_EXPLODED: PiePreview,
    DOUGHNUT: DoughnutPreview,
  };

  const props = defineProps({
    baseType: {
      type: String,
      default: "BAR_CLUSTERED",
    },
    colors: {
      type: Array,
      default: () => REPORT_THEME_DEFAULT_COLORS,
    },
    width: {
      type: Number,
      default: 120,
    },
    height: {
      type: Number,
      default: 80,
    },
    padding: {
      type: Number,
      default: 8,
    },
    seriesCount: {
      type: Number,
      default: 1,
    },
    categoryCount: {
      type: Number,
      default: 4,
    },
  });

  const previewComponent = computed(() => CHART_COMPONENTS[props.baseType] || BarClusteredPreview);

  const previewProps = computed(() => ({
    colors: props.colors,
    width: props.width,
    height: props.height,
    padding: props.padding,
    seriesCount: props.seriesCount,
    categoryCount: props.categoryCount,
    ...(props.baseType === "PIE_EXPLODED" && { exploded: true }),
  }));
</script>

<template>
  <svg
    :width="width"
    :height="height"
    :viewBox="`0 0 ${width} ${height}`">
    <component
      :is="previewComponent"
      v-bind="previewProps" />
  </svg>
</template>
